module.exports = __webpack_public_path__ + "static/media/supportPanelBackground.56172c05.png";